import { Button } from "@istari-frontend/ui";
import { ArrowRight } from "lucide-react";

import { cn } from "~/utils/cn";

interface ChatSuggestionChipProps {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

export function ChatSuggestionChip({ label, onClick, disabled, className }: ChatSuggestionChipProps) {
  return (
    <Button
      type="button"
      variant="secondary"
      size="sm"
      disabled={disabled}
      onClick={onClick}
      className={cn("h-auto justify-start gap-1.5 rounded-lg py-1.5 text-left whitespace-normal", className)}
    >
      <ArrowRight className="size-4 shrink-0" />
      {label}
    </Button>
  );
}
